/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getScopedTheme, getStylist } from 'src/core/themes/luisStylist';

export type ListItemsProps = {
    /**
     * The current selected Item to highlight.
     */
    currentSelection: number;
};

const messages = defineMessages({
    itemOne: {
        id: 'shared.listItems.itemOne',
        defaultMessage: '1. Design your schema'
    },
    itemTwo: {
        id: 'shared.listItems.itemTwo',
        defaultMessage: '2. Build your model'
    },
    itemThree: {
        id: 'shared.listItems.itemThree',
        defaultMessage: '3. Improve your app'
    }
});

const theme = getScopedTheme('ListItems');
const { styleComponent } = getStylist('ListItems');
const ItemsWrapper = styleComponent<IStackProps>(Stack)('ItemsWrapper', { paddingLeft: theme.paddingLeft, minWidth: theme.minWidth });

/**
 * The component rendering the side list with
 * the selection highlighted.
 */
export const ListItems = (props: ListItemsProps) => {
    const { currentSelection } = props;
    const { localize } = useLocalization();

    return (
        <ItemsWrapper tokens={{ childrenGap: 25 }} horizontalAlign="start">
            <LuisText fontWeight={currentSelection === 1 ? 'bold' : 'normal'}>{localize(messages.itemOne)}</LuisText>
            <LuisText fontWeight={currentSelection === 2 ? 'bold' : 'normal'}>{localize(messages.itemTwo)}</LuisText>
            <LuisText fontWeight={currentSelection === 3 ? 'bold' : 'normal'}>{localize(messages.itemThree)}</LuisText>
        </ItemsWrapper>
    );
};
